import React from 'react';
import { Twitter, Youtube, Mail, Instagram } from 'lucide-react';

const INSTAGRAM_URL = 'https://www.instagram.com/gal_war_cc/?utm_source=ig_web_button_share_sheet';

const SOCIALS = [
  { Icon: Instagram, href: INSTAGRAM_URL, label: 'Instagram', external: true },
  { Icon: Twitter, href: '#', label: 'Twitter', external: false },
  { Icon: Youtube, href: '#', label: 'YouTube', external: false },
  { Icon: Mail, href: '#', label: 'Email', external: false },
];

const INK = 'var(--text-primary)';
const STEEL = 'var(--text-muted)';
const RED = '#FF8618';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative overflow-hidden"
      data-testid="footer-section"
    >
      {/* subtle grid texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
          opacity: 0.7,
        }}
      />
      <div className="max-w-7xl mx-auto px-6 py-14 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/galwar-logo.png" alt="GAL WAR CC" className="w-11 h-11 object-contain" style={{ filter: 'drop-shadow(0 2px 6px rgba(40,60,90,0.25))' }} />
              <span className="text-2xl font-black uppercase tracking-[0.2em]" style={{ fontFamily: '"Rajdhani", sans-serif', fontWeight: 700, color: INK }}>
                GAL WAR CC
              </span>
            </div>
            <p className="mb-6 leading-relaxed max-w-md" style={{ color: 'var(--text-secondary)', fontFamily: '"Rajdhani", "Inter", sans-serif', fontWeight: 500 }}>
              Cosmic Conquest: Galactic War — the next generation of Battle Royale gaming.
              Battle among the stars in the ultimate intergalactic showdown.
            </p>
            <div className="flex gap-3">
              {SOCIALS.map(({ Icon, href, label, external }) => (
                <a
                  key={label}
                  href={href}
                  {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="social-ico w-10 h-10 flex items-center justify-center rounded-lg"
                  style={{ background: 'rgba(27,35,43,0.75)', border: '1px solid rgba(255, 134, 24, 0.45)', color: '#f2f4f6' }}
                  aria-label={label}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* GAME column */}
          <div>
            <h3 className="text-sm font-black mb-4 uppercase tracking-[0.32em]" style={{ fontFamily: '"Rajdhani", sans-serif', fontWeight: 700, color: RED }}>
              Game
            </h3>
            <ul className="space-y-2">
              {[
                { label: 'About', anchor: 'about' },
                { label: 'Features', anchor: 'features' },
                { label: 'Races', anchor: 'races' },
                { label: 'Map', anchor: 'map' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={`#${link.anchor}`}
                    className="text-xs font-bold tracking-[0.2em] uppercase transition-colors"
                    style={{ fontFamily: '"Rajdhani", sans-serif', fontWeight: 600, color: STEEL }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = RED; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = STEEL; }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* COMMUNITY column */}
          <div>
            <h3 className="text-sm font-black mb-4 uppercase tracking-[0.32em]" style={{ fontFamily: '"Rajdhani", sans-serif', fontWeight: 700, color: RED }}>
              Community
            </h3>
            <ul className="space-y-2">
              {['Discord', 'Forums', 'Support'].map((label) => (
                <li key={label}>
                  <a
                    href="#"
                    className="text-xs font-bold tracking-[0.2em] uppercase transition-colors"
                    style={{ fontFamily: '"Rajdhani", sans-serif', fontWeight: 600, color: STEEL }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = RED; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = STEEL; }}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="pt-7" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs tracking-[0.16em]" style={{ color: STEEL, fontFamily: '"Rajdhani", sans-serif', fontWeight: 500 }}>
              © {currentYear} Gal War CC Pvt. Ltd. All rights reserved.
            </p>
            <p className="text-[10px] tracking-[0.4em] uppercase" style={{ color: 'var(--text-subtle)', fontFamily: '"Rajdhani", sans-serif', fontWeight: 700 }}>
              Battle Royale · Sci-Fi · AAA Multiplayer
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
